import { useState, useRef, useEffect } from 'react';
import { useMsal } from "@azure/msal-react";
import useProfileData from '../../services/ProfileDataService';

const DropDownUser = () => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { instance } = useMsal();
  const { userName, profileImage } = useProfileData();

  const user = {
    name: userName,
    photo: profileImage
  };

  const handleLogout = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: "/",
    });
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  return (
    <div className="relative flex items-center" ref={dropdownRef}>
      <button
        className="flex items-center space-x-2 focus:outline-none"
        onClick={() => setOpen((prev) => !prev)}
        aria-haspopup="true"
        aria-expanded={open}
      >
        {user.photo && user.photo !== ''
          ? (
            <img src={user.photo} alt="user" className="h-8 w-8 rounded-full object-cover border-2 border-blue-400" />
          ) : (
            <div className="h-8 w-8 rounded-full object-cover border-2 border-blue-400 flex items-center justify-center bg-gray-100">
              <svg className="w-7 h-7 text-gray-300" fill="currentColor" viewBox="0 0 24 24">
                <circle cx="12" cy="7" r="5" />
                <path d="M12 14c-5 0-9 2.5-9 5v1h18v-1c0-2.5-4-5-9-5z" />
              </svg>
            </div>
          )}
        <span className="text-sm font-medium text-gray-700">{user.name}</span>
        <svg className="w-4 h-4 ml-1 text-gray-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" /></svg>
      </button>
      {open && (
        <div className="absolute top-full mt-2 w-40 bg-white border rounded shadow-lg z-20 animate-fade-in" style={{ left: '-10px' }}>
          <button className="block w-full px-4 py-2 text-left text-sm hover:bg-gray-100" onClick={handleLogout}>Sign Out</button>
        </div>
      )}
    </div>
  );
};

export default DropDownUser;